export const blockIconsDeviceQuiz = (
	<span className='material-symbols-outlined'>quiz</span>
);
